const print = () => {

  const printBtns = document.querySelectorAll(".share-button.--print");

  printBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      window.print();
    })
  });
}

print();
